import { Column, Row } from "@react-email/components";

interface AddressSectionProps {
  address: string | null;
  styles?: Record<string, string | number>;
}

export const AddressSection = ({
  address,
  styles = {},
}: AddressSectionProps) => {
  if (!address) {
    return null;
  }

  return (
    <Row style={styles}>
      <Column align="center">
        {/*
          This span is used to target the footer community address in the visual email builder content html.
          Changing the id will break the visual email builder content html.
          If you need to change the id, you must also update the footer community address in the VisualEmailBuilderContentService.
        */}
        <span id="footer-community-address">{address}</span>
      </Column>
    </Row>
  );
};
